import { HttpClient } from '@angular/common/http';
import { Component, Injector, OnInit } from '@angular/core';
import { CoreClass } from '@src/app/core/base/core.class';
import { IMAGES_URL, ALL_SERVICES, LOGIN_PATH, CEHAS_ACCESS_ACCOUNT, PLUS_MEMBERSHIP, COMMON_MODULES, CREAT_PASSWORD_PATH, BUY_MEMBERSHIP } from '@src/app/core/constants';
import { HelperService } from '@src/app/core/services/helper.service';
import { MembershipPlanModule } from '@src/app/core/shared/components/membership-plan/membership-plan.module';
import { MiniEnvContentBoxComponent } from '@src/app/core/shared/components/mini-env/mini-env-content-box/mini-env-content-box.component';
import { MiniEnvFaqsComponent } from '@src/app/core/shared/components/mini-env/mini-env-faqs/mini-env-faqs.component';
import { SearchMedicationComponent } from '@src/app/core/shared/components/mini-env/search-medication/search-medication.component';
import { BannerOneModule } from '@src/app/core/shared/components/ui/banner/banner-one/banner-one.module';
import { MiniEnvBannerComponent } from '@src/app/core/shared/components/ui/banner/mini-env-banner/mini-env-banner.component';
import { CardboxOneModule } from '@src/app/core/shared/components/ui/cardbox/cardbox-one/cardbox-one.module';
import { HeadingBlockFullWidthModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-fullwidth/heading-block-fullwidth.module';
import { HeadingBlockOneModule } from '@src/app/core/shared/components/ui/heading-box/heading-block-one/heading-block-one.module';
import { MiniEnvHeadingBlockComponent } from '@src/app/core/shared/components/ui/heading-box/mini-env-heading-block/mini-env-heading-block.component';
import { IconboxOneModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-one/iconbox-one.module';
import { IconboxTwoModule } from '@src/app/core/shared/components/ui/iconbox/iconbox-two/iconbox-two.module';
import { ImageboxBulletScrollComponent } from '@src/app/core/shared/components/ui/imagebox/imagebox-bullet-scroll/imagebox-bullet-scroll.component';
import { ImageboxFullwidthModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-fullwidth/imagebox-fullwidth.module';
import { ImageboxOneModule } from '@src/app/core/shared/components/ui/imagebox/imagebox-one/imagebox-one.module';
import { VideoPlayerComponent } from '@src/app/core/shared/components/video-player/video-player.component';

@Component({
  selector: 'app-iac',
  imports: [...COMMON_MODULES,
          HeadingBlockOneModule,
          IconboxOneModule,
          IconboxTwoModule,
          HeadingBlockFullWidthModule,
          ImageboxOneModule,
          ImageboxFullwidthModule,
          CardboxOneModule,
          BannerOneModule,
          ImageboxBulletScrollComponent,
          MiniEnvHeadingBlockComponent,
          MiniEnvFaqsComponent,
          MiniEnvBannerComponent,
          MembershipPlanModule,
          VideoPlayerComponent,
          MiniEnvContentBoxComponent,
         SearchMedicationComponent],
  templateUrl: './iac.component.html',
  styleUrl: './iac.component.scss'
})
export class IacComponent extends CoreClass implements OnInit {
IMAGES_URL: string = IMAGES_URL;
  faqList = [];
  imgSrc = 'assets/tenant-assets/mini-env/images/package-delivery.png';
  get_started_bg = 'assets/tenant-assets/mini-env/images/father-child.png';
  imgLink = 'assets/tenant-assets/mini-env/images/laptop-and-phone.svg';
  medication_bg = this.sharedService.miniEnvPath + 'iac/man-with-phone.png';

  // public language: string = ""
  // style = 'font-size: 64px;line-height: 78px';
  constructor(
    injector: Injector,
    private httpClient: HttpClient,
    private readonly helperService: HelperService
  ) {
    super(injector);
  }
  All_SERVICES_PATH: string = ALL_SERVICES;
  serviceDetails: any;


  benefits = [
    {
      id: '01',
      title: 'Flexibility',
      description: 'Manage your health with comprehensive in-person and virtual care options that fit your schedule and medical needs.',
      bgImage: 'd-shape'
    },
    {
      id: '02',
      title: 'Affordability',
      description: 'Free virtual services, and direct-pay for in-person care with exclusive discounts, so you pay less than with an insurance plan.',
      bgImage: 'circles'
    },
    {
      id: '03',
      title: 'Transparency',
      description: 'Know the total cost of care when you make an appointment, and pay at the time of service. Goodbye surprises & bills in the mail.',
      bgImage: 'm-shape'
    },
  ];

  faqs: any[] = [
  {
    question: 'What is the difference between WoW Plus & health insurance?',
    answer: 'WoW Plus provides steeply discounted access to medical providers... It is not insurance but a direct pay network...'
  },
  {
    question: 'Why do I need WoW Health?',
    answer: 'It provides affordable access to routine care and prescriptions...'
  }
];

bannerSlides: any[] = [
  {
    title: 'Smarter Savings on the Medications You Need',
    subtitle: 'Get access to free and discounted prescriptions without the usual complications. Transparent pricing, seamless access, and real savings for both short-term and ongoing care.',
    link: '/join',
    buttonText: 'Explore Membership',
    buttonText2: 'Member Login',
    buttonAction: 'membership',
    buttonAction1: 'login',
    buttonAction2: 'create-password',
    bannerClass: 'iac-banner',
    info: 'First Time User?',
    buttonText3: 'Create Password',
  },
];

 steps = [
    {
      id: '01',
      title: '01. Log In to Your Account',
      description: 'Log in and visit your pharmacy dashboard.'
    },
    {
      id: '02',
      title: '02. Explore Your Pharmacy Benefits',
      description: 'Browse available medications to view pricing, delivery, & pick-up options'
    },
    {
      id: '03',
      title: '03. Get Started With Medications Simplified',
      description: 'Inform your doctor to send prescriptions to your preferred pharmacy.'
    },
  ];

  ngOnInit(): void {
    this.sharedService.removeNavbarLinks = false;
    this.getFAQs();
    this.helperService.changeMiniEnvColor();
    const config = this.storageService.getMiniEnvConfig(); 

    // if (config.primaryColor) {
    //   document.documentElement.style.setProperty('--primarycolor', config.primaryColor);
    //   document.documentElement.style.setProperty('--primary-mini-env-2', config.primaryColor2);
    //   document.documentElement.style.setProperty('--primary-mini-env-3', config.primaryColor3);
    //   document.documentElement.style.setProperty('--primaryOutlineColor', config.primaryColor2);
    //   document.documentElement.style.setProperty('--secondarycolor', config.secondaryColor);
    // }

   this.getService();
  }

  async getService() {
    try {
      const services = await this.sharedService.getServicesForTabs(); 
      this.serviceDetails = services.find((s: any) => s.serviceCode === 'telehealth_services');
    } catch (error) {
      console.error('Error fetching services for tabs:', error);
    }
  }

  login() {
    this.router.navigateByUrl(LOGIN_PATH);
  }

  onSliderBtnAction(action: any) {
    if (action == 'membership') {
      this.router.navigateByUrl(BUY_MEMBERSHIP + `?plan=${this.storageService.getMiniEnvConfig().membershipPlanTypes}`);
    }
    else if (action == 'login') {
      this.router.navigateByUrl(LOGIN_PATH);
    }
    else {
      this.router.navigateByUrl(CREAT_PASSWORD_PATH);
    }
  }

  getStartedAction() {
    this.router.navigateByUrl(BUY_MEMBERSHIP + `?plan=${this.storageService.getMiniEnvConfig().membershipPlanTypes}`);
  }

  getFAQs() {
    const apiUrl = `/assets/i18n/mini-env/iac/${this.sharedService.currentLanguage}.json`;
    this.httpClient.get(apiUrl).subscribe((json: any) => {
      this.faqList = json.FAQS.FAQ_LIST;
    });
  }
}
